export const migrateCustomerInitialState = {
  oldMobileNumber: '',
  newMobileNumber: ''
};
